
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5 15.5h-4A1.5 1.5 0 010 14v-4a1.5 1.5 0 011.5-1.5h4A1.5 1.5 0 017 10v4a1.5 1.5 0 01-1.5 1.5zm-4-6a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4A.5.5 0 006 14v-4a.5.5 0 00-.5-.5zm21 6h-4A1.5 1.5 0 0117 14v-4a1.5 1.5 0 011.5-1.5h4A1.5 1.5 0 0124 10v4a1.5 1.5 0 01-1.5 1.5zm-4-6a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5zm-4.36 3H9.5a.5.5 0 010-1h4.64a.5.5 0 010 1z"}}),_c('path',{attrs:{"d":"M12.46 14.5a.5.5 0 01-.35-.86L13.8 12l-1.68-1.64a.5.5 0 01.7-.72l2.04 2a.5.5 0 010 .72l-2.04 2a.5.5 0 01-.35.14z"}})])
          )
        }
      }
    